module.exports = __webpack_public_path__ + "img/imgZXGH(25).be0fb193.png";